<ngx-file-drop
  dropZoneLabel="Drop files here"
  (onFileDrop)="onFileDrop.emit($event)"
  [accept]="fileAcceptedFormat()"
  [useDragEnter]="useDragEnter()"
>
  <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
    <div class="d-flex d-xl-none py-2 gap-2 align-items-center" (click)="openFileSelector()">
      <svg-icon name="upload-file" class="svg-32 svg-primary"></svg-icon
      ><span class="text-secondary fw-500">{{ titleMsg() }}</span>
    </div>
    <div
      class="align-items-center d-none d-xl-flex flex-fill gap-3 justify-content-center dragfiles"
      role="button"
      (click)="openFileSelector()"
    >
      <div class="w-75 d-flex align-items-center gap-2 justify-content-center">
        <svg-icon name="upload-file"></svg-icon>
        <div class="d-flex flex-column">
          <span class="fs-14 text-gray-300 fw-500">Drag and Drop to</span>
          <span class="fs-20 text-dark fw-500">{{ titleMsg() }}</span>
          <span class="fs-14 text-gray-300 fw-500">{{ fileAcceptedFormat() }}</span>
        </div>
      </div>
    </div>
  </ng-template>
</ngx-file-drop>
